import { type BetslipStatus } from '../../../../types/betslip';
import { type ObjectValuesUnionType } from '../../../../utils/typing';

export const UserMissionStatuses = {
  OPEN: 'OPEN',
  WON: 'WON',
  LOST: 'LOST',
};
export type UserMissionStatus = ObjectValuesUnionType<typeof UserMissionStatuses>;

export const UserAchievementStatuses = {
  OPEN: 'OPEN',
  PENDING: 'PENDING',
  WON: 'WON',
  LOST: 'LOST',
  CANCELLED: 'CANCELLED',
};
export type UserAchievementStatus = ObjectValuesUnionType<typeof UserAchievementStatuses>;

export type UserBetslipState = {
  userId: number;
  betslipId: number;
  betslipReference: string;
  betslipStatus: BetslipStatus;
  matchIds: Array<number>;
  validationDate: number;
  betAmount: number;
  odds: number;
  achievementStatus: UserAchievementStatus;
};

export type UserMissionAchievementState = {
  achievementId: number;
  status: UserAchievementStatus;
  wonDate?: number | null;
  bets: Array<string>; // array of betslipReferences
  betslips: {
    [betslipReference: string]: UserBetslipState;
  };
};

export type UserMissionState = {
  missionId: number;
  startTime?: number;
  wonDate?: number | null;
  status?: UserMissionStatus;
  hasUserRegistered?: boolean;
  achievements?: {
    [achievementId: number]: UserMissionAchievementState;
  };
};

export type UserMissions = {
  [missionId: number]: UserMissionState;
};
